export const translations = {
  'es-419': {
    translation: {
      showToday: 'Mostrar hoy',
      outOfRange: 'fuera de rango',
      selectUpToDays: 'Seleccione una fecha dentro de los {maxDays} días',
      From: 'Desde',
      FromToDateRangeError: `La fecha hasta no puede ser anterior a la fecha desde`,
      to: 'Hasta',
      dateFrom: 'Fecha desde',
      loadingError: 'Error al cargar',
      contactAdmin:
        'Actualice la página para cargar los datos. Comuníquese con su administrador si el problema persiste.',
      searchFor: 'Buscar',
      nodes: 'Nodos',
      cancel: 'Cancelar',
      back: 'Atrás',
      saveAndContinue: 'Guardar y continuar',
      yes: 'Sí',
      no: 'No',
      electDateRange: 'Seleccione el rango de fechas entre {días} días',
      Today: 'Hoy',
      Yesterday: 'Ayer',
      LastWeek: 'La semana pasada',
      ThisMonth: 'este mes',
      LastMonth: 'Mes pasado',
      Last3Months: 'Últimos 3 meses',
      Last6Months: 'Últimos 6 meses',
      YearToDate: 'El año hasta la fecha',
      LastYear: 'El año pasado',
      datePickerErrorMsg:
        'Seleccione las fechas dentro del rango de {días} meses.',
      datePickerGreaterErrorMessage:
        'Desde la fecha no puede ser mayor que hasta la fecha',
      Duration: 'Duración',
      To: 'To',
      apply: 'Aplicar',
      name: 'nombre',
      type: 'tipo',
      Finish: 'Finalizar'
    }
  }
};
